import RPA from '@master/model/kyc-form/RPA'
import { Default } from '@master/annotation/Default'

export default class CustomRPA extends RPA {
  @Default('as_per_questionnaire')
  riskProfile = ''
}
